import {LayoutDimData} from "../../../../core/utils/ResizeHelper";
import {PREngineManager} from "../../../punkEngine/PREngineManager";
import {SpinePlayer} from "../../../../core/displayobject/SpinePlayer";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class OtherOverlays extends PIXI.Container {
    private _bottomTrainVisible: boolean = false;
    private _trainBlastSpine: SpinePlayer;

    constructor() {
        super();
        this.name = "OtherOverlays";
        this.init();
    }

    onResize(): void {
        const scaledReelDim: LayoutDimData = this._bottomTrainVisible ? PREngineManager.dimScaled : PREngineManager.dim;

        this.scale.set(scaledReelDim.scale.x, scaledReelDim.scale.y);
        if(NolimitApplication.isLandscape) {
            this._trainBlastSpine.position.x = 630;
        }else {
            this._trainBlastSpine.position.x = 600;
        }
    }

    public onBottomTrainShow(flag: boolean, isRestore: boolean = false): void {
        this._bottomTrainVisible = flag;
        this.onResize();
    }

    public playTrainBlast(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline(),
            animName: string = "animation",
            animDur: number = this._trainBlastSpine.fetchDuration(animName);

        tl.add(() => {
            this._trainBlastSpine.play({
                animation: animName
            });
        });

        tl.to(this, {
            duration: animDur
        });

        return tl;
    }

    private init(): void {
        this.createTrainBlast();
        this.onResize();
    }

    private createTrainBlast(): void {
        this._trainBlastSpine = this.addChild(new SpinePlayer("trainBlast"));
        this._trainBlastSpine.position.set(600, 698);
        this._trainBlastSpine.scale.set(1.25);
        this.addChild(this._trainBlastSpine);
    }
}